<template>
    <section class="mb-8">
        <h4 class="text-slate-800 dark:text-slate-100 font-medium mb-4">Rental car</h4>
        <div class="px-4 py-5 rounded-lg border border-slate-200 dark:border-slate-700">
            <div
                class="flex justify-between pb-3 mb-4 border-b border-slate-200 dark:border-slate-700"
            >
                <div class="text-slate-800 dark:text-slate-100 text-sm font-medium">
                    <span v-if="!hideSensitiveData">
                        {{ travelDate }}
                    </span>
                    <span v-else class="text-slate-400">Hidden</span>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import { computed } from 'vue';
import dayjs from 'dayjs';

const props = defineProps({
    activeRedemption: Object,
    isSharedView: {
        type: Boolean,
        default: false,
    },
    hideSensitiveData: {
        type: Boolean,
        default: false,
    },
});

const travelDate = computed(() => {
    if (
        !props.activeRedemption?.start_date ||
        !props.activeRedemption?.end_date
    )
        return '';
    return (
        dayjs(props.activeRedemption.start_date).format('MMM D') +
        ' - ' +
        dayjs(props.activeRedemption.end_date).format('MMM D, YYYY')
    );
});
</script>
